export function generateRecommendationHTML(recommendation) {
    return `
    <div class="d-flex justify-content-between flex-column h-100">
        <div>
            <a class="viewed-products__item__image" href="${recommendation.link}" title="${recommendation.name}">
              <img class="mx-auto" src="${recommendation.link_image}" alt="${recommendation.name}" width="100%">
            </a>
            <a class="viewed-products__item__title" href="${recommendation.link}" title="${recommendation.name}">${recommendation.name}</a>

        </div>
        <div class="small-stars" style="display: block;">
          <div id="brekz_productreviews">
            <!-- TrustBox widget -->
            <div id="trustpilot-product-small" itemscope itemtype="http://schema.org/Product">
              <span class="trustpilot-reviews-summary trustpilot-clearfix">
                <div class="trustpilot-star-rating trustpilot-size-small trustpilot-count-${recommendation.stars} trustpilot-clearfix">
                  <div class="trustpilot-star-1"><img alt="4" title="${recommendation.stars}" src="//images-static.trustpilot.com/community/shared/sprite_star.png" class="trustpilot-star-image trustpilot-star-image_recommend"></div>
                  <div class="trustpilot-star-2"><img alt="4" title="${recommendation.stars}" src="//images-static.trustpilot.com/community/shared/sprite_star.png" class="trustpilot-star-image trustpilot-star-image_recommend"></div>
                  <div class="trustpilot-star-3"><img alt="4" title="${recommendation.stars}" src="//images-static.trustpilot.com/community/shared/sprite_star.png" class="trustpilot-star-image trustpilot-star-image_recommend"></div>
                  <div class="trustpilot-star-4"><img alt="4" title="${recommendation.stars}" src="//images-static.trustpilot.com/community/shared/sprite_star.png" class="trustpilot-star-image trustpilot-star-image_recommend"></div>
                  <div class="trustpilot-star-5"><img alt="4" title="${recommendation.stars}" src="//images-static.trustpilot.com/community/shared/sprite_star.png" class="trustpilot-star-image trustpilot-star-image_recommend"></div>
                </div>
                <span class="trustpilot-aggregate-rating" itemprop="aggregateRating" itemscope itemtype="http://schema.org/AggregateRating">
                  <span class="trustpilot-review-count">(<span itemprop="reviewCount">${recommendation.review_count}</span>)</span>
                </span>
              </span>
            </div>
            <!-- End TrustBox widget -->
          </div>
        </div>
    </div>
  `;
}
